/* tslint:disable */
/* eslint-disable */
/**
 * TOM PLANNING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BulkUpdateContainerVisitCommand } from '../model';
// @ts-ignore
import type { BulkUpdateContainerVisitNotesCommand } from '../model';
// @ts-ignore
import type { ContainerAttributesDto } from '../model';
// @ts-ignore
import type { ContainerCharacteristics } from '../model';
// @ts-ignore
import type { ContainerDto } from '../model';
// @ts-ignore
import type { ContainerEventDto } from '../model';
// @ts-ignore
import type { ContainerHistoryAdditionalDataResponseDto } from '../model';
// @ts-ignore
import type { ContainerInfoForTallyResponseDto } from '../model';
// @ts-ignore
import type { ContainerResponseDto } from '../model';
// @ts-ignore
import type { ContainerResponseDtoPaginatedList } from '../model';
// @ts-ignore
import type { ContainerType } from '../model';
// @ts-ignore
import type { CreateContainerDamageCommand } from '../model';
// @ts-ignore
import type { CreateContainerVisitCommand } from '../model';
// @ts-ignore
import type { CreateOverlandedContainerVisitCommand } from '../model';
// @ts-ignore
import type { GetContainersByIdsQuery } from '../model';
// @ts-ignore
import type { GetLinkableOrdersQueryQuery } from '../model';
// @ts-ignore
import type { OrderResponseDto } from '../model';
// @ts-ignore
import type { ResolveContainerDamagesCommand } from '../model';
// @ts-ignore
import type { SyncContainersDto } from '../model';
// @ts-ignore
import type { SyncStatus } from '../model';
// @ts-ignore
import type { UnitType } from '../model';
// @ts-ignore
import type { UnresolveContainerDamagesCommand } from '../model';
// @ts-ignore
import type { UpdateContainerVisitCommand } from '../model';
// @ts-ignore
import type { UploadContainerDamageImagesResponseDto } from '../model';
// @ts-ignore
import type { UpsertContainerCommand } from '../model';
/**
 * ContainersApi - axios parameter creator
 */
export const ContainersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {GetLinkableOrdersQueryQuery} [getLinkableOrdersQueryQuery] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        activeOrders: async (getLinkableOrdersQueryQuery?: GetLinkableOrdersQueryQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Containers/ActiveOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getLinkableOrdersQueryQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkUpdateContainerVisitCommand} [bulkUpdateContainerVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateContainerVisit: async (bulkUpdateContainerVisitCommand?: BulkUpdateContainerVisitCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Containers/BulkUpdateContainerVisit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateContainerVisitCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkUpdateContainerVisitNotesCommand} [bulkUpdateContainerVisitNotesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateContainerVisitNotes: async (bulkUpdateContainerVisitNotesCommand?: BulkUpdateContainerVisitNotesCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Containers/BulkUpdateContainerVisitNotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateContainerVisitNotesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [containerNumber] 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerDamageImages: async (containerNumber?: string, files?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Containers/ContainerDamageImages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


            if (containerNumber !== undefined) { 
                localVarFormParams.append('ContainerNumber', containerNumber as any);
            }
            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('Files', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {CreateContainerVisitCommand} [createContainerVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContainerVisit: async (id: number, createContainerVisitCommand?: CreateContainerVisitCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createContainerVisit', 'id', id)
            const localVarPath = `/planning/api/Containers/{id}/CreateContainerVisit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContainerVisitCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateOverlandedContainerVisitCommand} [createOverlandedContainerVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOverlandedContainerVisit: async (createOverlandedContainerVisitCommand?: CreateOverlandedContainerVisitCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Containers/CreateOverlandedContainerVisit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOverlandedContainerVisitCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {CreateContainerDamageCommand} [createContainerDamageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damage: async (id: number, createContainerDamageCommand?: CreateContainerDamageCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damage', 'id', id)
            const localVarPath = `/planning/api/Containers/{id}/Damage`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContainerDamageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} number 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        events: async (number: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('events', 'number', number)
            const localVarPath = `/planning/api/Containers/{number}/Events`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {UnitType} [unitType] 
         * @param {SyncStatus} [syncStatus] 
         * @param {string} [filter] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [orderBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (page: number, pageSize: number, unitType?: UnitType, syncStatus?: SyncStatus, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('get', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('get', 'pageSize', pageSize)
            const localVarPath = `/planning/api/Containers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (unitType !== undefined) {
                localVarQueryParameter['UnitType'] = unitType;
            }

            if (syncStatus !== undefined) {
                localVarQueryParameter['SyncStatus'] = syncStatus;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (includeCompleted !== undefined) {
                localVarQueryParameter['IncludeCompleted'] = includeCompleted;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['OrderBy'] = orderBy;
            }

            if (isDescending !== undefined) {
                localVarQueryParameter['IsDescending'] = isDescending;
            }

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetContainersByIdsQuery} [getContainersByIdsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds: async (getContainersByIdsQuery?: GetContainersByIdsQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Containers/GetByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getContainersByIdsQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [containerNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContainerAttributes: async (containerNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Containers/GetContainerAttributes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (containerNumber !== undefined) {
                localVarQueryParameter['containerNumber'] = containerNumber;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} isoCode 
         * @param {boolean} onlyStandard 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContainerCharacteristicsByIsoCode: async (isoCode: string, onlyStandard: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'isoCode' is not null or undefined
            assertParamExists('getContainerCharacteristicsByIsoCode', 'isoCode', isoCode)
            // verify required parameter 'onlyStandard' is not null or undefined
            assertParamExists('getContainerCharacteristicsByIsoCode', 'onlyStandard', onlyStandard)
            const localVarPath = `/planning/api/Containers/GetContainerCharacteristicsByIsoCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (isoCode !== undefined) {
                localVarQueryParameter['IsoCode'] = isoCode;
            }

            if (onlyStandard !== undefined) {
                localVarQueryParameter['OnlyStandard'] = onlyStandard;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [userIds] 
         * @param {Array<number>} [carrierVisitIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContainerHistoryAdditionalData: async (userIds?: Array<string>, carrierVisitIds?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Containers/GetContainerHistoryAdditionalData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (userIds) {
                localVarQueryParameter['UserIds'] = userIds;
            }

            if (carrierVisitIds) {
                localVarQueryParameter['CarrierVisitIds'] = carrierVisitIds;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [containerNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContainerInfoForTallyQuery: async (containerNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Containers/GetContainerInfoForTallyQuery`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (containerNumber !== undefined) {
                localVarQueryParameter['ContainerNumber'] = containerNumber;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} filter 
         * @param {boolean} [isEmpty] 
         * @param {boolean} [isOnTerminal] 
         * @param {string} [isoCode] 
         * @param {string} [operator] 
         * @param {boolean} [hasServiceOrders] 
         * @param {boolean} [canAssignServiceOrders] 
         * @param {ContainerType} [type] 
         * @param {boolean} [includeRestow] 
         * @param {boolean} [canAssignStrippingOrder] 
         * @param {boolean} [canAssignStuffingOrder] 
         * @param {boolean} [canAssignCoolingOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContainersByPartialNumber: async (filter: string, isEmpty?: boolean, isOnTerminal?: boolean, isoCode?: string, operator?: string, hasServiceOrders?: boolean, canAssignServiceOrders?: boolean, type?: ContainerType, includeRestow?: boolean, canAssignStrippingOrder?: boolean, canAssignStuffingOrder?: boolean, canAssignCoolingOrder?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filter' is not null or undefined
            assertParamExists('getContainersByPartialNumber', 'filter', filter)
            const localVarPath = `/planning/api/Containers/GetContainersByPartialNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (isEmpty !== undefined) {
                localVarQueryParameter['IsEmpty'] = isEmpty;
            }

            if (isOnTerminal !== undefined) {
                localVarQueryParameter['IsOnTerminal'] = isOnTerminal;
            }

            if (isoCode !== undefined) {
                localVarQueryParameter['IsoCode'] = isoCode;
            }

            if (operator !== undefined) {
                localVarQueryParameter['Operator'] = operator;
            }

            if (hasServiceOrders !== undefined) {
                localVarQueryParameter['HasServiceOrders'] = hasServiceOrders;
            }

            if (canAssignServiceOrders !== undefined) {
                localVarQueryParameter['CanAssignServiceOrders'] = canAssignServiceOrders;
            }

            if (type !== undefined) {
                localVarQueryParameter['Type'] = type;
            }

            if (includeRestow !== undefined) {
                localVarQueryParameter['IncludeRestow'] = includeRestow;
            }

            if (canAssignStrippingOrder !== undefined) {
                localVarQueryParameter['CanAssignStrippingOrder'] = canAssignStrippingOrder;
            }

            if (canAssignStuffingOrder !== undefined) {
                localVarQueryParameter['CanAssignStuffingOrder'] = canAssignStuffingOrder;
            }

            if (canAssignCoolingOrder !== undefined) {
                localVarQueryParameter['CanAssignCoolingOrder'] = canAssignCoolingOrder;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetLinkableOrdersQueryQuery} [getLinkableOrdersQueryQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkableOrders: async (getLinkableOrdersQueryQuery?: GetLinkableOrdersQueryQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Containers/LinkableOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getLinkableOrdersQueryQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertContainerCommand} [upsertContainerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post: async (upsertContainerCommand?: UpsertContainerCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Containers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertContainerCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recomputeContainerCharacteristics: async (body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Containers/RecomputeContainerCharacteristics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ResolveContainerDamagesCommand} [resolveContainerDamagesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveDamages: async (id: number, resolveContainerDamagesCommand?: ResolveContainerDamagesCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resolveDamages', 'id', id)
            const localVarPath = `/planning/api/Containers/{id}/ResolveDamages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resolveContainerDamagesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [from] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        sync: async (from?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Containers/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UnresolveContainerDamagesCommand} [unresolveContainerDamagesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unresolveDamages: async (id: number, unresolveContainerDamagesCommand?: UnresolveContainerDamagesCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unresolveDamages', 'id', id)
            const localVarPath = `/planning/api/Containers/{id}/UnresolveDamages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unresolveContainerDamagesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateContainerVisitCommand} [updateContainerVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContainerVisit: async (updateContainerVisitCommand?: UpdateContainerVisitCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Containers/UpdateContainerVisit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateContainerVisitCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} isoCodes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateIsoCodeList: async (isoCodes: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'isoCodes' is not null or undefined
            assertParamExists('validateIsoCodeList', 'isoCodes', isoCodes)
            const localVarPath = `/planning/api/Containers/ValidateIsoCodeList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (isoCodes) {
                localVarQueryParameter['IsoCodes'] = isoCodes;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContainersApi - functional programming interface
 */
export const ContainersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContainersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {GetLinkableOrdersQueryQuery} [getLinkableOrdersQueryQuery] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async activeOrders(getLinkableOrdersQueryQuery?: GetLinkableOrdersQueryQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activeOrders(getLinkableOrdersQueryQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.activeOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BulkUpdateContainerVisitCommand} [bulkUpdateContainerVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateContainerVisit(bulkUpdateContainerVisitCommand?: BulkUpdateContainerVisitCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateContainerVisit(bulkUpdateContainerVisitCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.bulkUpdateContainerVisit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BulkUpdateContainerVisitNotesCommand} [bulkUpdateContainerVisitNotesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateContainerVisitNotes(bulkUpdateContainerVisitNotesCommand?: BulkUpdateContainerVisitNotesCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateContainerVisitNotes(bulkUpdateContainerVisitNotesCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.bulkUpdateContainerVisitNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [containerNumber] 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerDamageImages(containerNumber?: string, files?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UploadContainerDamageImagesResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerDamageImages(containerNumber, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.containerDamageImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {CreateContainerVisitCommand} [createContainerVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContainerVisit(id: number, createContainerVisitCommand?: CreateContainerVisitCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContainerVisit(id, createContainerVisitCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.createContainerVisit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateOverlandedContainerVisitCommand} [createOverlandedContainerVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOverlandedContainerVisit(createOverlandedContainerVisitCommand?: CreateOverlandedContainerVisitCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOverlandedContainerVisit(createOverlandedContainerVisitCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.createOverlandedContainerVisit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {CreateContainerDamageCommand} [createContainerDamageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damage(id: number, createContainerDamageCommand?: CreateContainerDamageCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damage(id, createContainerDamageCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.damage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} number 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async events(number: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.events(number, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.events']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {UnitType} [unitType] 
         * @param {SyncStatus} [syncStatus] 
         * @param {string} [filter] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [orderBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(page: number, pageSize: number, unitType?: UnitType, syncStatus?: SyncStatus, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerResponseDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(page, pageSize, unitType, syncStatus, filter, includeCompleted, orderBy, isDescending, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetContainersByIdsQuery} [getContainersByIdsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIds(getContainersByIdsQuery?: GetContainersByIdsQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIds(getContainersByIdsQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.getByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [containerNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContainerAttributes(containerNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerAttributesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContainerAttributes(containerNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.getContainerAttributes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} isoCode 
         * @param {boolean} onlyStandard 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContainerCharacteristicsByIsoCode(isoCode: string, onlyStandard: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerCharacteristics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContainerCharacteristicsByIsoCode(isoCode, onlyStandard, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.getContainerCharacteristicsByIsoCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [userIds] 
         * @param {Array<number>} [carrierVisitIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContainerHistoryAdditionalData(userIds?: Array<string>, carrierVisitIds?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerHistoryAdditionalDataResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContainerHistoryAdditionalData(userIds, carrierVisitIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.getContainerHistoryAdditionalData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [containerNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContainerInfoForTallyQuery(containerNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerInfoForTallyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContainerInfoForTallyQuery(containerNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.getContainerInfoForTallyQuery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} filter 
         * @param {boolean} [isEmpty] 
         * @param {boolean} [isOnTerminal] 
         * @param {string} [isoCode] 
         * @param {string} [operator] 
         * @param {boolean} [hasServiceOrders] 
         * @param {boolean} [canAssignServiceOrders] 
         * @param {ContainerType} [type] 
         * @param {boolean} [includeRestow] 
         * @param {boolean} [canAssignStrippingOrder] 
         * @param {boolean} [canAssignStuffingOrder] 
         * @param {boolean} [canAssignCoolingOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContainersByPartialNumber(filter: string, isEmpty?: boolean, isOnTerminal?: boolean, isoCode?: string, operator?: string, hasServiceOrders?: boolean, canAssignServiceOrders?: boolean, type?: ContainerType, includeRestow?: boolean, canAssignStrippingOrder?: boolean, canAssignStuffingOrder?: boolean, canAssignCoolingOrder?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContainersByPartialNumber(filter, isEmpty, isOnTerminal, isoCode, operator, hasServiceOrders, canAssignServiceOrders, type, includeRestow, canAssignStrippingOrder, canAssignStuffingOrder, canAssignCoolingOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.getContainersByPartialNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetLinkableOrdersQueryQuery} [getLinkableOrdersQueryQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkableOrders(getLinkableOrdersQueryQuery?: GetLinkableOrdersQueryQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkableOrders(getLinkableOrdersQueryQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.linkableOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertContainerCommand} [upsertContainerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async post(upsertContainerCommand?: UpsertContainerCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.post(upsertContainerCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.post']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recomputeContainerCharacteristics(body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recomputeContainerCharacteristics(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.recomputeContainerCharacteristics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ResolveContainerDamagesCommand} [resolveContainerDamagesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveDamages(id: number, resolveContainerDamagesCommand?: ResolveContainerDamagesCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveDamages(id, resolveContainerDamagesCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.resolveDamages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [from] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async sync(from?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncContainersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sync(from, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.sync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {UnresolveContainerDamagesCommand} [unresolveContainerDamagesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unresolveDamages(id: number, unresolveContainerDamagesCommand?: UnresolveContainerDamagesCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unresolveDamages(id, unresolveContainerDamagesCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.unresolveDamages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateContainerVisitCommand} [updateContainerVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContainerVisit(updateContainerVisitCommand?: UpdateContainerVisitCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContainerVisit(updateContainerVisitCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.updateContainerVisit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} isoCodes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateIsoCodeList(isoCodes: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateIsoCodeList(isoCodes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainersApi.validateIsoCodeList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContainersApi - factory interface
 */
export const ContainersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContainersApiFp(configuration)
    return {
        /**
         * 
         * @param {GetLinkableOrdersQueryQuery} [getLinkableOrdersQueryQuery] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        activeOrders(getLinkableOrdersQueryQuery?: GetLinkableOrdersQueryQuery, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderResponseDto>> {
            return localVarFp.activeOrders(getLinkableOrdersQueryQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkUpdateContainerVisitCommand} [bulkUpdateContainerVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateContainerVisit(bulkUpdateContainerVisitCommand?: BulkUpdateContainerVisitCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bulkUpdateContainerVisit(bulkUpdateContainerVisitCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkUpdateContainerVisitNotesCommand} [bulkUpdateContainerVisitNotesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateContainerVisitNotes(bulkUpdateContainerVisitNotesCommand?: BulkUpdateContainerVisitNotesCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bulkUpdateContainerVisitNotes(bulkUpdateContainerVisitNotesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [containerNumber] 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerDamageImages(containerNumber?: string, files?: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<Array<UploadContainerDamageImagesResponseDto>> {
            return localVarFp.containerDamageImages(containerNumber, files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {CreateContainerVisitCommand} [createContainerVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContainerVisit(id: number, createContainerVisitCommand?: CreateContainerVisitCommand, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.createContainerVisit(id, createContainerVisitCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateOverlandedContainerVisitCommand} [createOverlandedContainerVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOverlandedContainerVisit(createOverlandedContainerVisitCommand?: CreateOverlandedContainerVisitCommand, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.createOverlandedContainerVisit(createOverlandedContainerVisitCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {CreateContainerDamageCommand} [createContainerDamageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damage(id: number, createContainerDamageCommand?: CreateContainerDamageCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.damage(id, createContainerDamageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} number 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        events(number: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerEventDto>> {
            return localVarFp.events(number, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {UnitType} [unitType] 
         * @param {SyncStatus} [syncStatus] 
         * @param {string} [filter] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [orderBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(page: number, pageSize: number, unitType?: UnitType, syncStatus?: SyncStatus, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<ContainerResponseDtoPaginatedList> {
            return localVarFp.get(page, pageSize, unitType, syncStatus, filter, includeCompleted, orderBy, isDescending, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetContainersByIdsQuery} [getContainersByIdsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds(getContainersByIdsQuery?: GetContainersByIdsQuery, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerResponseDto>> {
            return localVarFp.getByIds(getContainersByIdsQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [containerNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContainerAttributes(containerNumber?: string, options?: RawAxiosRequestConfig): AxiosPromise<ContainerAttributesDto> {
            return localVarFp.getContainerAttributes(containerNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} isoCode 
         * @param {boolean} onlyStandard 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContainerCharacteristicsByIsoCode(isoCode: string, onlyStandard: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ContainerCharacteristics> {
            return localVarFp.getContainerCharacteristicsByIsoCode(isoCode, onlyStandard, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [userIds] 
         * @param {Array<number>} [carrierVisitIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContainerHistoryAdditionalData(userIds?: Array<string>, carrierVisitIds?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<ContainerHistoryAdditionalDataResponseDto> {
            return localVarFp.getContainerHistoryAdditionalData(userIds, carrierVisitIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [containerNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContainerInfoForTallyQuery(containerNumber?: string, options?: RawAxiosRequestConfig): AxiosPromise<ContainerInfoForTallyResponseDto> {
            return localVarFp.getContainerInfoForTallyQuery(containerNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} filter 
         * @param {boolean} [isEmpty] 
         * @param {boolean} [isOnTerminal] 
         * @param {string} [isoCode] 
         * @param {string} [operator] 
         * @param {boolean} [hasServiceOrders] 
         * @param {boolean} [canAssignServiceOrders] 
         * @param {ContainerType} [type] 
         * @param {boolean} [includeRestow] 
         * @param {boolean} [canAssignStrippingOrder] 
         * @param {boolean} [canAssignStuffingOrder] 
         * @param {boolean} [canAssignCoolingOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContainersByPartialNumber(filter: string, isEmpty?: boolean, isOnTerminal?: boolean, isoCode?: string, operator?: string, hasServiceOrders?: boolean, canAssignServiceOrders?: boolean, type?: ContainerType, includeRestow?: boolean, canAssignStrippingOrder?: boolean, canAssignStuffingOrder?: boolean, canAssignCoolingOrder?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerDto>> {
            return localVarFp.getContainersByPartialNumber(filter, isEmpty, isOnTerminal, isoCode, operator, hasServiceOrders, canAssignServiceOrders, type, includeRestow, canAssignStrippingOrder, canAssignStuffingOrder, canAssignCoolingOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetLinkableOrdersQueryQuery} [getLinkableOrdersQueryQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkableOrders(getLinkableOrdersQueryQuery?: GetLinkableOrdersQueryQuery, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderResponseDto>> {
            return localVarFp.linkableOrders(getLinkableOrdersQueryQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertContainerCommand} [upsertContainerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(upsertContainerCommand?: UpsertContainerCommand, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.post(upsertContainerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recomputeContainerCharacteristics(body?: object, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recomputeContainerCharacteristics(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ResolveContainerDamagesCommand} [resolveContainerDamagesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveDamages(id: number, resolveContainerDamagesCommand?: ResolveContainerDamagesCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resolveDamages(id, resolveContainerDamagesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [from] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        sync(from?: string, options?: RawAxiosRequestConfig): AxiosPromise<SyncContainersDto> {
            return localVarFp.sync(from, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UnresolveContainerDamagesCommand} [unresolveContainerDamagesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unresolveDamages(id: number, unresolveContainerDamagesCommand?: UnresolveContainerDamagesCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unresolveDamages(id, unresolveContainerDamagesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateContainerVisitCommand} [updateContainerVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContainerVisit(updateContainerVisitCommand?: UpdateContainerVisitCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateContainerVisit(updateContainerVisitCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} isoCodes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateIsoCodeList(isoCodes: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.validateIsoCodeList(isoCodes, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContainersApi - object-oriented interface
 */
export class ContainersApi extends BaseAPI {
    /**
     * 
     * @param {GetLinkableOrdersQueryQuery} [getLinkableOrdersQueryQuery] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public activeOrders(getLinkableOrdersQueryQuery?: GetLinkableOrdersQueryQuery, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).activeOrders(getLinkableOrdersQueryQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkUpdateContainerVisitCommand} [bulkUpdateContainerVisitCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bulkUpdateContainerVisit(bulkUpdateContainerVisitCommand?: BulkUpdateContainerVisitCommand, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).bulkUpdateContainerVisit(bulkUpdateContainerVisitCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkUpdateContainerVisitNotesCommand} [bulkUpdateContainerVisitNotesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bulkUpdateContainerVisitNotes(bulkUpdateContainerVisitNotesCommand?: BulkUpdateContainerVisitNotesCommand, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).bulkUpdateContainerVisitNotes(bulkUpdateContainerVisitNotesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [containerNumber] 
     * @param {Array<File>} [files] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerDamageImages(containerNumber?: string, files?: Array<File>, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).containerDamageImages(containerNumber, files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {CreateContainerVisitCommand} [createContainerVisitCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createContainerVisit(id: number, createContainerVisitCommand?: CreateContainerVisitCommand, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).createContainerVisit(id, createContainerVisitCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateOverlandedContainerVisitCommand} [createOverlandedContainerVisitCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOverlandedContainerVisit(createOverlandedContainerVisitCommand?: CreateOverlandedContainerVisitCommand, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).createOverlandedContainerVisit(createOverlandedContainerVisitCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {CreateContainerDamageCommand} [createContainerDamageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public damage(id: number, createContainerDamageCommand?: CreateContainerDamageCommand, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).damage(id, createContainerDamageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} number 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public events(number: string, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).events(number, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {UnitType} [unitType] 
     * @param {SyncStatus} [syncStatus] 
     * @param {string} [filter] 
     * @param {boolean} [includeCompleted] 
     * @param {string} [orderBy] 
     * @param {boolean} [isDescending] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public get(page: number, pageSize: number, unitType?: UnitType, syncStatus?: SyncStatus, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).get(page, pageSize, unitType, syncStatus, filter, includeCompleted, orderBy, isDescending, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetContainersByIdsQuery} [getContainersByIdsQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getByIds(getContainersByIdsQuery?: GetContainersByIdsQuery, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).getByIds(getContainersByIdsQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [containerNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getContainerAttributes(containerNumber?: string, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).getContainerAttributes(containerNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} isoCode 
     * @param {boolean} onlyStandard 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getContainerCharacteristicsByIsoCode(isoCode: string, onlyStandard: boolean, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).getContainerCharacteristicsByIsoCode(isoCode, onlyStandard, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [userIds] 
     * @param {Array<number>} [carrierVisitIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getContainerHistoryAdditionalData(userIds?: Array<string>, carrierVisitIds?: Array<number>, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).getContainerHistoryAdditionalData(userIds, carrierVisitIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [containerNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getContainerInfoForTallyQuery(containerNumber?: string, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).getContainerInfoForTallyQuery(containerNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} filter 
     * @param {boolean} [isEmpty] 
     * @param {boolean} [isOnTerminal] 
     * @param {string} [isoCode] 
     * @param {string} [operator] 
     * @param {boolean} [hasServiceOrders] 
     * @param {boolean} [canAssignServiceOrders] 
     * @param {ContainerType} [type] 
     * @param {boolean} [includeRestow] 
     * @param {boolean} [canAssignStrippingOrder] 
     * @param {boolean} [canAssignStuffingOrder] 
     * @param {boolean} [canAssignCoolingOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getContainersByPartialNumber(filter: string, isEmpty?: boolean, isOnTerminal?: boolean, isoCode?: string, operator?: string, hasServiceOrders?: boolean, canAssignServiceOrders?: boolean, type?: ContainerType, includeRestow?: boolean, canAssignStrippingOrder?: boolean, canAssignStuffingOrder?: boolean, canAssignCoolingOrder?: boolean, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).getContainersByPartialNumber(filter, isEmpty, isOnTerminal, isoCode, operator, hasServiceOrders, canAssignServiceOrders, type, includeRestow, canAssignStrippingOrder, canAssignStuffingOrder, canAssignCoolingOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetLinkableOrdersQueryQuery} [getLinkableOrdersQueryQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public linkableOrders(getLinkableOrdersQueryQuery?: GetLinkableOrdersQueryQuery, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).linkableOrders(getLinkableOrdersQueryQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertContainerCommand} [upsertContainerCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public post(upsertContainerCommand?: UpsertContainerCommand, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).post(upsertContainerCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public recomputeContainerCharacteristics(body?: object, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).recomputeContainerCharacteristics(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ResolveContainerDamagesCommand} [resolveContainerDamagesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resolveDamages(id: number, resolveContainerDamagesCommand?: ResolveContainerDamagesCommand, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).resolveDamages(id, resolveContainerDamagesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [from] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public sync(from?: string, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).sync(from, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UnresolveContainerDamagesCommand} [unresolveContainerDamagesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unresolveDamages(id: number, unresolveContainerDamagesCommand?: UnresolveContainerDamagesCommand, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).unresolveDamages(id, unresolveContainerDamagesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateContainerVisitCommand} [updateContainerVisitCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateContainerVisit(updateContainerVisitCommand?: UpdateContainerVisitCommand, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).updateContainerVisit(updateContainerVisitCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} isoCodes 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateIsoCodeList(isoCodes: Array<string>, options?: RawAxiosRequestConfig) {
        return ContainersApiFp(this.configuration).validateIsoCodeList(isoCodes, options).then((request) => request(this.axios, this.basePath));
    }
}

